import React from 'react';

export const PageHeader = ({ title, description, children }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-testid="page-header">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900 font-heading">{title}</h1>
        {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
};
